import { generateFormData } from "../../Utils/common";

class ProfileService {
  static getProfile() {
    return { url: `/me/profile`, method: "get" };
  }

  static getPermissions() {
    return { url: `/me/permissions`, method: "get" };
  }

  static update(data) {
    return { url: `/me/profile`, method: "put", data: generateFormData(data) };
  }
}

export default ProfileService;
